import createIcon from '../../createIcon';

/**
 * @component @name AddPhotoAlternate
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSA3LjVWMTAuNDlDMTguNSAxMC40OSAxNi41MSAxMC41IDE2LjUgMTAuNDlWNy41SDEzLjVDMTMuNSA3LjUgMTMuNTEgNS41MSAxMy41IDUuNUgxNi41VjIuNUgxOC41VjUuNUgyMS41VjcuNUgxOC41Wk0xNS41IDExLjVWOC41SDEyLjVWNS41SDQuNUMzLjQgNS41IDIuNSA2LjQgMi41IDcuNVYxOS41QzIuNSAyMC42IDMuNCAyMS41IDQuNSAyMS41SDE2LjVDMTcuNiAyMS41IDE4LjUgMjAuNiAxOC41IDE5LjVWMTEuNUgxNS41Wk00LjUgMTkuNUw3LjUgMTUuNUw5LjUgMTguNUwxMi41IDE0LjVMMTYuNSAxOS41SDQuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddPhotoAlternate = createIcon('AddPhotoAlternate', [
  [
    'path',
    {
      d: 'M18.5 7.5V10.49C18.5 10.49 16.51 10.5 16.5 10.49V7.5H13.5C13.5 7.5 13.51 5.51 13.5 5.5H16.5V2.5H18.5V5.5H21.5V7.5H18.5ZM15.5 11.5V8.5H12.5V5.5H4.5C3.4 5.5 2.5 6.4 2.5 7.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H16.5C17.6 21.5 18.5 20.6 18.5 19.5V11.5H15.5ZM4.5 19.5L7.5 15.5L9.5 18.5L12.5 14.5L16.5 19.5H4.5Z',
      key: '1v8xjj',
    },
  ],
]);

export default AddPhotoAlternate;
